import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import HablemosDeTuMSica from "./sections/HablemosDeTuMSica";
import FormularioDeProyecto from "./sections/FormularioDeProyecto";
import PreguntasFrecuentes from "./sections/PreguntasFrecuentes";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <HablemosDeTuMSica />
      <FormularioDeProyecto />
      <PreguntasFrecuentes />
      <Footer />
    </div>;
}